import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.QBooksBudgets.BudgetSettingsPopupContent', {
    title: 'Settings for {budgetName}',
    saveButton: 'Save',
    description: 'Please select budget check period for ”{name}” budget.',
    checkPeriodTitle: 'Budget check period',
    monthly: '1 month',
    quarterly: 'Financial quarter',
    annually: 'Financial year',
    zeroAmountSettingTitle: 'How should 0 planned amount be handled on the request?',
});
